import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { loginModel } from '../../Interface/login';
import { ApiRequestsService, RESPONSE } from '../../services/api-requests.service';
import { DataManipulateService } from '../../services/data-manipulate.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CommonFunctionService } from '../../services/common-function.service';


@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule]
})
export class LoginPageComponent {
  public model: loginModel = { loginId: '', password: '', devType: 'W' };
  // public model: loginModel = { loginId: 'omkar', password: 'omkar@123', devType: 'W' };
  showPassword: boolean = false;
  errorEmployeeid: string = '';
  errorPassword: string = '';
  errorMsg: string = '';
  inputType: string = 'password';
  changePassword: boolean = false;
  constructor(
    private apiRequests: ApiRequestsService,
    private route: Router,
    private toaster: ToastrService,
    private data: DataManipulateService,
    private common: CommonFunctionService
  ) {
    this.apiRequests.setUnAutorisedHandler(this.common.unAuthorizedHandlerFunction);
  }

  login = async () => {
    this.errorEmployeeid = '';
    this.errorPassword = '';
    this.errorMsg = '';
    this.apiRequests.setUnAutorisedHandler(this.common.unAuthorizedHandlerFunction);
    if (!window.navigator.onLine) {
      this.toaster.error('No Internet Connection');
    } else if (!this.model.loginId && !this.model.password) {
      this.errorMsg = 'Please Enter LoginId and Password';
    } else if (!this.model.loginId) {
      this.errorEmployeeid = 'Please enter Login Id';
    } else if (!this.model.password) {
      this.errorPassword = 'Please enter password';
    } else {
      const { errorCode, errorDescription, Data } = await this.apiRequests.postAPICallWithPromise('user/userLogin', this.model);
      if (errorCode == this.apiRequests.NO_ERROR) {
        this.apiRequests.updateOrSetTokenValue(Data.ntk);
        this.changePassword = Data['changePassword'] || 0;
        this.data.userInfo = Data.userInfo;
        this.toaster.success(errorDescription);
        if (this.changePassword) {
          this.route.navigate(['/change-password']);
        } else {
          this.route.navigate(['/user-dashboard']);
        }

      } else {
        this.errorMsg = errorDescription;
        this.toaster.error(errorDescription);
      }
    }
  };

  passwordVisibility() {
    this.showPassword = !this.showPassword;
    this.inputType = (this.showPassword) ? 'text' : 'password';
  }


}
